import { Trans } from '@lingui/macro'
import { MenuItem, TextField } from '@mui/material'
import { HELP_CASE_TYPES } from 'app/services/sfAuth/sfData/sfCaseTypes'
import React from 'react'
import { useDispatch } from 'react-redux'

export const FormEditorInquiry: React.FC<{}> = ({
  depth,
  typeProps,
  injectable,
  ...props
}) => {
  const dispatch = useDispatch()
  const { variant, color, type } = typeProps

  return (
    <div>
      <TextField
        select
        fullWidth
        variant='outlined'
        value={variant ?? 'contained'}
        style={{ marginTop: 10 }}
        label={<Trans>VARIANT</Trans>}
        onChange={(e) => {
          const toSet = { ...typeProps }
          toSet.variant = e.target.value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      >
        <MenuItem value='outlined'>
          <Trans>
            OUTLINED
          </Trans>
        </MenuItem>
        <MenuItem value='contained'>
          <Trans>
            CONTAINED
          </Trans>
        </MenuItem>
        <MenuItem value='text'>
          <Trans>
            TEXT
          </Trans>
        </MenuItem>
      </TextField>

      <TextField
        select
        fullWidth
        variant='outlined'
        value={color ?? 'primary'}
        style={{ marginTop: 10 }}
        label={<Trans>COLOR</Trans>}
        onChange={(e) => {
          const toSet = { ...typeProps }
          toSet.color = e.target.value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      >
        <MenuItem value='primary'>
          <Trans>
            PRIMARY
          </Trans>
        </MenuItem>
        <MenuItem value='secondary'>
          <Trans>
            SECONDARY
          </Trans>
        </MenuItem>
      </TextField>

      <TextField
        select
        fullWidth
        variant='outlined'
        value={type ?? ''}
        style={{ marginTop: 10 }}
        label={<Trans>INQUIRY_TYPE</Trans>}
        onChange={(e) => {
          const toSet = { ...typeProps }
          toSet.type = e.target.value
          dispatch({
            type: 'FIELD',
            injectable,
            depth: depth.split('.'),
            fieldName: 'typeProps',
            fieldValue: { ...toSet }
          })
        }}
      >
        {Object.keys(HELP_CASE_TYPES)
          .filter(key => key !== 'ENVIRONMENTAL_SAT')
          .map(key => {
            return (
              <MenuItem value={key} key={key}>
                {key}
              </MenuItem>
            )
          })}
      </TextField>
    </div>
  )
}
